import { Environment } from '@snelstart/models-environment';
import { EnvironmentSettings } from './environment-settings';

export const environment: EnvironmentSettings = {
    production: false,
    type: Environment.Development,
    identityStoreDomain: 'login-tst.snelstart.nl',
    identityStoreClientId: 'o7iDQ914vQpg99RVAURIzi1pAgdA4Hy5',
    identityStoreAudience: 'https://webapi-tst.snelstart.nl',
    allowedList_snelstart: 'https://api-dev.snelstart.nl/*',
    allowedList_snelstart_legacy: 'https://webapi-tst.snelstart.nl/*',
    allowedList_bokkz: 'https://test.leukermakkelijker.nl/*',
    mfes: {},
    // suiteBaseUrl:'https://suite-dev.snelstart.nl/'
    suiteBaseUrl: 'http://localhost:4200/',
    fiscaalBaseUrl: 'https://fiscaal-dev.snelstart.nl/',
    userpilotToken: 'STG-NX-5dce9e2e',

    // suiteBaseUrl:'http://localhost:4200/',
    appInsights: {
      instrumentationKey: '69002197-54b5-4f82-864a-e971c469be5a',
    },
};
